/**
 * Lower-cases and strips diacritics so filtering is case- and accent-insensitive.
 */
export const normalizeString = (str: string): string =>
  str
    .toLocaleLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

/**
 * Filters rows by a normalized substring match on a single field.
 * Returns the data unchanged when there is no active search term or filter field.
 * Rows whose field value is null/undefined are excluded while filtering.
 */
export const filterRows = <T>(data: T[], filterField: keyof T | undefined, search: string): T[] => {
  if (!search) return data
  return data.filter(item => {
    if (filterField && search) {
      const fieldValue = item[filterField]
      if (fieldValue === null || fieldValue === undefined) return false
      return normalizeString(String(fieldValue)).includes(normalizeString(search))
    }
    return true
  })
}
